import React from "react";
import useFeatureFlags from "../../../../common/feature-flags/useFeatureFlags";
import useVisibilityState from "../../../../common/forms/useVisibilityState";
import useRolesRestrictions from "../../../../common/roles/useRolesRestrictions";
import useRolesVisibility from "../../../../common/roles/useRolesVisibility";
import { RestrictedCriterion } from "../RestrictedCriterion";
import { requiredRolesType } from "../../../../common/types/search/search";
import { visibilitySelectorType } from "../../../../common/types/common";

interface SearchCriterionProps {
	children: React.ReactNode;
	label: string;
	prefix?: string;
	quickSearch: boolean;
	requiredRoles?: requiredRolesType;
	requiredFeatureFlag?: string;
	visibilitySelector?: visibilitySelectorType;
}

export function SearchCriterion({
	children,
	label,
	prefix,
	quickSearch,
	requiredFeatureFlag,
	requiredRoles,
	visibilitySelector,
}: SearchCriterionProps) {
	const visible = useVisibilityState(visibilitySelector);
	const { restrictOnRoles } = useRolesRestrictions(requiredRoles);
	const { hasRequiredRoles } = useRolesVisibility(requiredRoles);
	const { hasFeatureFlagEnabled } = useFeatureFlags(requiredFeatureFlag);

	if (!visible || !hasRequiredRoles || !hasFeatureFlagEnabled) {
		return null;
	}

	if (restrictOnRoles.length > 0) {
		return (
			<RestrictedCriterion
				label={label}
				prefix={prefix}
				roles={restrictOnRoles}
				quickSearch={quickSearch}
			/>
		);
	}

	return children;
}
